import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { uploadFileToUserFolder } from '../../services/mediaService';

export default function UploadsPage() {
  const { user } = useAuth();
  const [folder, setFolder] = useState('misc');
  const [pending, setPending] = useState(false);
  const [progress, setProgress] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const [uploadedItems, setUploadedItems] = useState([]);

  async function handleUpload(event) {
    const file = event.target.files?.[0];
    if (!file || !user) {
      return;
    }

    setPending(true);
    setErrorMessage('');
    setProgress(0);

    try {
      const upload = await uploadFileToUserFolder({
        userId: user.uid,
        folder,
        file,
        onProgress: (value) => setProgress(value),
      });

      setUploadedItems((current) => [
        {
          name: upload.name,
          path: upload.fullPath,
          url: upload.downloadURL,
          contentType: upload.contentType,
          size: upload.size,
        },
        ...current,
      ]);
    } catch (error) {
      setErrorMessage(error.message ?? 'Upload failed.');
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="page-stack">
      <section className="section-heading">
        <div>
          <p className="eyebrow">Storage Utility</p>
          <h1>Direct Uploads</h1>
          <p>
            Upload utility files to `users/{user.uid}/{folder}`. Use content
            manager pages for article/animation/model-linked uploads.
          </p>
        </div>
      </section>

      <div className="upload-box">
        {errorMessage ? <p className="form-error">{errorMessage}</p> : null}

        <label>
          Folder
          <input
            value={folder}
            onChange={(event) => setFolder(event.target.value.trim() || 'misc')}
            placeholder="misc"
          />
        </label>

        <label>
          File
          <input type="file" onChange={handleUpload} disabled={pending} />
        </label>

        {pending ? <p className="upload-status">Uploading... {progress}%</p> : null}
      </div>

      <div className="upload-results">
        <h2>Recent uploads</h2>
        {uploadedItems.length === 0 ? (
          <div className="state-card">
            <p>No uploads in this session.</p>
          </div>
        ) : (
          <ul className="upload-list">
            {uploadedItems.map((item) => (
              <li key={item.path}>
                <p>{item.name}</p>
                <p>{item.path}</p>
                <a href={item.url} target="_blank" rel="noreferrer noopener">
                  Open file
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
